











import { Component, Vue, Watch } from 'vue-property-decorator'
import { uuid } from 'vue-uuid'

@Component({
  name: 'c-collected-data-chart'
})
export default class CollectedDataChart extends Vue {
  updateArgs: boolean[] = [true, true, true]
  id: string =  uuid.v1().replace(/\-/g, '')

  chartOptions = {
    chart: {
      zoomType: 'x',
      height: '350px',
      backgroundColor: '#F3F2F7',
      borderRadius: 10,

      marginRight: '30',
      marginTop: '50',
      marginBottom: '50'
    },

    title: {
      text: ''
    },

    subtitle: {
      text:
        document.ontouchstart === undefined
          ? this.$t('statistic.collectedDataChart.subtitle')
          : this.$t('statistic.collectedDataChart.subtitleTouched')
    },

    credits: {
      enabled: false
    },

    xAxis: {
      type: 'datetime'
    },

    yAxis: {
      title: {
        text: this.$t('statistic.collectedDataChart.totalScans')
      }
    },

    legend: {
      enabled: false
    },

    plotOptions: {
      area: {
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1
          }
        },

        marker: {
          radius: 2
        },

        lineWidth: 1,

        states: {
          hover: {
            lineWidth: 1
          }
        },

        threshold: null
      }
    },

    series: [
      {
        name: this.$t('statistic.collectedDataChart.totalScansShort'),
        data: []
      }
    ]
  }

  get isUpdated () {
    return this.$store.getters['statistics/getUpdateStatus']
  }

  get shardsForHours () {
    return this.$store.getters['statistics/getShardsForHours'].sort(
      (a: any, b: any) => a.time - b.time
    )
  }

  mounted (): void {
    this.updateSeries()
  }

  @Watch('shardsForHours')
  isShardsForHoursChanged () {
    this.updateSeries()
  }

  @Watch('isUpdated')
  isUpdatedChanged (oldData: any, newData: any) {
    if (oldData === newData) return

    this.updateSeries()
    this.$store.state.statistics.isUpdated = false
  }

  protected updateSeries (): void {
    let scans: any[] = []

    this.shardsForHours.forEach((elem: any) => {
      scans.push([elem.time * 1000, elem.total])
    })

    const elem: any = this.$refs.charts

    console.log([...scans])

    elem.chart.update({
      series: [
        {
          name: this.$t('statistic.collectedDataChart.totalScansShort'),
          data: [...scans]
        }
      ]
    })
  }
}
